import React, { useEffect } from 'react';
import '@op/opds.styles/css/elements.css';
import '@op/opds.styles/css/text.css';
import { RouterProvider } from 'react-router-dom';
import ErrorBoundary from './individual/components/common/ErrorBoundary';
import { initializeHeartbeat } from 'api/heartbeat-api';
import getRouter from 'router';
import { getInitialState } from 'utils';

function App() {
  useEffect(() => {
    if (!getInitialState().authenticatedCustomer) {
      initializeHeartbeat();
    }
  }, []);

  return (
    <ErrorBoundary>
      <RouterProvider
        router={getRouter()}
        future={{ v7_startTransition: true }}
      />
    </ErrorBoundary>
  );
}

export default App;
